export const APPLICATION_JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export enum HTTP_METHOD {
  GET = "GET",
  POST = "POST",
}

export function withJwt(jwt: string, headers: Record<string, string> = {}) {
  return {
    ...APPLICATION_JSON_HEADERS,
    ...headers,
    Authorization: `Bearer ${jwt}`,
  };
}
